module.exports = __webpack_public_path__ + "img/question.2e1fadfd.svg";